import { render, staticRenderFns } from "./CharitableGifts.vue?vue&type=template&id=610bfc8c"
import script from "./CharitableGifts.vue?vue&type=script&lang=js"
export * from "./CharitableGifts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports